import type { LocationDescriptor } from 'history';
import type { HTMLAttributes, ReactNode } from 'react';
import type { LinkProps } from 'react-router-dom';
import type { LabelData } from '../Label';

export type CardItemBadgeColor = 'blue' | 'lightBlue' | 'purple' | 'yellow' | 'red' | 'green';

export interface CardItemBadge {
  label: string;
  image?: string;
  icon?: ReactNode;
  color: CardItemBadgeColor;
  expanded?: boolean;
}

export interface CardItemSubtitleBadge {
  label: string;
  expanded?: boolean;
}
export interface CardContentCustom {
  title?: ReactNode;
  subtitle?: ReactNode;
  text?: ReactNode;
}

export interface CardItemProps extends Omit<HTMLAttributes<HTMLDivElement>, 'id' | 'content'> {
  image?: string | null;
  imageOverlay?: ReactNode;
  imageButton?: ReactNode;
  badges?: CardItemBadge[];
  subtitleBadges?: CardItemSubtitleBadge[];
  content?: CardContentCustom;
  footer?: ReactNode;
  label?: LabelData;
  backgroundColor?: string;
  hideHoverOverlay?: boolean;
  link?: LocationDescriptor;
  linkWrapperProps?: Omit<LinkProps, 'to'>;
  loading?: boolean;
  lazyLoadImage?: boolean;
  useHeadingForTitle?: boolean;
  shrinkHeightMobile?: boolean;
}
